import { render } from "./QualificationDropdown.vue?vue&type=template&id=9de4be8a"
import script from "./QualificationDropdown.vue?vue&type=script&lang=js"
export * from "./QualificationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__